module.exports = __webpack_public_path__ + "c3953bca8bdc9a680036228ff8de00b4.png";